import { io } from 'socket.io-client';
import configJson from '../../../../../../sites/common_site_config.json';

export function initSocket() {
  let host = window.location.hostname;
  // let siteName = import.meta.env.DEV ? host : window.site_name
  let port = window.location.port ? `:${configJson.socketio_port}` : '';
  let protocol = port ? 'http' : 'https';
  let url = `${protocol}://${host}${port}`;
  // let url = `${protocol}://${host}${port}/${siteName}`
  let socket = io(url, {
    withCredentials: true,
    reconnectionAttempts: 5,
  });
  return socket;
}
